import { useMsal } from "@azure/msal-react";

import { JenlyLogo } from "../components/JenlyLogo";
import { MicrosoftLogo } from "../components/MicrosoftLogo";
import { apiTokenRequest } from "./msalConfig";

/** The gate in front of the app: a single Entra sign-in, no PINs or shared passcodes. */
export function SignInScreen(): JSX.Element {
  const { instance } = useMsal();

  return (
    <div className="centred-screen">
      <div className="card sign-in-card">
        <JenlyLogo variant="full" height={54} className="sign-in-logo" />
        <h1>Team Time Tracker</h1>
        <p className="muted">Sign in with your work account to log your hours.</p>
        <button
          type="button"
          className="primary sign-in-button"
          onClick={() => void instance.loginRedirect(apiTokenRequest)}
        >
          <MicrosoftLogo />
          <span>Sign in with Microsoft</span>
        </button>
      </div>
    </div>
  );
}
